<template>
  <div class="paper">
    <div slot="title">Add Inventory</div>
    <br />
      <div slot="form" v-if="loaded">
        <div class="form-group">
            <div class="row">
            <div class="col-md-6 m-t-sm">
              <div class="col-md-4 m-t-sm"><strong>Website</strong></div>
              <div class="col-md-8">
                <input type="text" name="" class="form-control" v-model="inventory['website']">
              </div>
            </div>
            <div class="col-md-6 m-t-sm">
              <div class="col-md-4 m-t-xs"><strong>TLD:</strong></div>
              <div class="col-md-8">
                <v-select placeholder="Tld" :options="tld" v-model="inventory['tld']"></v-select>
              </div>
            </div>
            </div>
            <div class="row">
              <div class="col-lg-6 m-t-sm">
                <div class="col-lg-4 m-t-xs"><strong>Content</strong></div>
                <div class="col-lg-8">
                  <select v-model="inventory.content">
                  <option v-for="item in bool" :key="item.val" :value="item.val">{{item.text}}</option>
                </select>
                </div>
              </div>
              <div class="col-lg-6 m-t-sm">
                <div class="col-lg-4"><strong>Webmaster Name</strong></div>
                <div class="col-lg-8">
                  <input type="text" name="" class="form-control" v-model="inventory['webmaster']['name']">
                </div>
              </div>
            </div>
            <div class="row">
            <div class="col-lg-6 m-t-sm">
              <div class="col-lg-4 m-t-sm"><strong>Webmaster Email</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['webmaster']['email']">
              </div>
            </div>
            <div class="col-lg-6 m-t-sm">
              <div class="col-lg-4 m-t-sm"><strong>Ahrefs Traffic</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['ahrefs']['traffic']">
              </div>
            </div>
            </div>
        </div>
            <div class="row">
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Ahrefs Rank</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['ahrefs']['rank']">
              </div>
              </div>
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Ahrefs DR</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['ahrefs']['dr']">
              </div>
              </div>
              </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Ahrefs RD</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['ahrefs']['rd']">
              </div>
              </div>
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Ahrefs Keywords</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['ahrefs']['keywords']">
              </div>
              </div>
              </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Webmaster Cost</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['webmaster']['cost']" @input="(e)=>onInput(e, 'cost')">
              </div>
            </div>
            <div class="col-lg-6">
              <div class="col-lg-4 m-t-sm"><strong>Client Price</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['clientPrice']" readonly>
              </div>
              </div>
            </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Link Type</strong></div>
              <div class="col-lg-8">
                <v-select placeholder="Link Type" :options="linkType" label="label" index="value" v-model="inventory['linkType']"></v-select>
              </div>
              </div>
              <div class="col-lg-6">
                <div class="col-lg-4"><strong>Duration</strong></div>
                <div class="col-lg-8">
                  <select v-model="inventory['duration']">
                    <option v-for="option in duration" :key="option.value" :value="option.value">{{ option.label }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Rule Casino</strong></div>
              <div class="col-lg-8">
                <select v-model="inventory['ruleCasino']">
                  <option v-for="item in bool" :key="item.val" :value="item.val">{{item.text}}</option>
                </select>
              </div>
              </div>
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Category</strong></div>
              <div class="col-lg-8">
                <v-select v-model="inventory['category']" :options="categories" multiple>
                </v-select>
              </div>
              </div>
              </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Langage</strong></div>
              <div class="col-lg-8">
                <v-select v-model="inventory['languages']" :options="languages">
                </v-select>
              </div>
              </div>
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Active</strong></div>
              <div class="col-lg-8">
                <!--
                <v-select :options="bool" label="label" value="value"  v-model="inventory['active']"></v-select>
                  -->
                <select v-model="inventory['active']">
                  <option v-for="item in bool" :key="item.val" :value="item.val">{{item.text}}</option>
                </select>
              </div>
              </div>
              </div>
            <div class="row m-t-sm">
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>1 Year Homepage Price</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['yearHomepagePrice']" @input="(e)=>onInput(e, 'homepage')">
              </div>
              </div>
            <div class="col-lg-6">
              <div class="col-lg-4"><strong>Homepage Rental Client Price</strong></div>
              <div class="col-lg-8">
                <input type="text" name="" class="form-control" v-model="inventory['homepageRentalClientPrice']" readonly>
              </div>
              </div>
              </div>
          <div class="row m-t-md m-r-xs">
            <div class="col-lg-12 text-right">
              <button class="btn btn-sm btn-primary" @click="updateInventory">Update</button>
            </div>
          </div>
      </div>
  </div>
</template>

<script>
import axios from 'axios'
import Modal from '@/components/Helpers/Modal/Form'

const calculateWebmasterCost = function (webmasterCost) {
  switch (true) {
    case webmasterCost < 51:
      return (webmasterCost * (1 + 1.25)).toFixed(2)
    case webmasterCost < 101:
      return (webmasterCost * (1 + 0.75)).toFixed(2)
    case webmasterCost < 201:
      return (webmasterCost * (1 + 0.6)).toFixed(2)
    case webmasterCost < 501:
      return (webmasterCost * (1 + 0.4)).toFixed(2)
    default:
      return (webmasterCost * (1 + 0.3)).toFixed(2)
  }
}

export default {
  data () {
    return {
      bool: [{text: 'Yes', val: 'true'}, {text: 'No', val: 'false'}],
      loaded: false,
      inventory: {
        webmaster: {
          name: '',
          email: '',
          cost: ''
        },
        ahrefs: {
          traffic: '',
          rank: '',
          dr: '',
          rd: '',
          keywords: ''
        }
      },
      tld: [],
      categories: [],
      languages: [],
      content: [
        { label: 'English', value: 'English' },
        { label: 'French', value: 'French' },
        { label: 'German', value: 'German' }
      ],
      linkType: [
        { label: 'Blog Post', value: 'Blog Post' },
        { label: 'Home Page', value: 'Home Page' }
      ],
      duration: [
        { label: 'Permanent', value: 'Permanent' },
        { label: '1 Month', value: '1 Month' },
        { label: '6 Months', value: '6 Months' },
        { label: '1 Year', value: '1 Year' },
        { label: '2 Years', value: '2 Years' },
        { label: '3 Years', value: '3 Years' }
      ]
    }
  },
  mounted () {
    this.getInventory()
  },
  components: {
    modalForm: Modal
  },
  methods: {
    async onInput (e, item) {
      if (item === 'cost') {
        this.inventory.clientPrice = calculateWebmasterCost(e.target.value)
      } else if (item === 'homepage') {
        this.inventory.homepageRentalClientPrice = calculateWebmasterCost(e.target.value)
      }
    },
    async updateInventory () {
      try {
        await axios.post(`/v2/instalinko/inventory`, this.inventory)
        this.$toastr.success('Inventory updated successfully', 'Brilliant stuff lad')
        this.$router.push({ name: 'Inventory' })
      } catch (err) {
        this.$toastr.error(err, 'Unable to get inventory')
      }
    },
    async getInventory () {
      try {
        const [tld, categories, languages] = await Promise.all([
          axios.get(`/v2/instalinko/inventory/tlds`),
          axios.get(`/v2/instalinko/inventory/categories`),
          axios.get(`/v2/instalinko/inventory/languages`)
        ])
        this.tld = tld.data.filter(item => item && item.length > 1)
        this.languages = languages.data
        this.categories = categories.data
        console.log(this.categories)
        this.loaded = true
      } catch (err) {
        this.$toastr.error(err, 'Unable to get inventory')
      }
    }
  }
}
</script>
<style>
.paper{
background: #fff;
padding:20px;
margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/Instalinko/InventoryAdd.vue